<template>
  <div class="padding-content">

    <!-- Contenido -->
    <div class="padding-content table-components-temporary shadow-sm bg-gray-50">
      <br />
      <!-- Modal para agregar componentes -->
      <ModalPlusComponents
        ref="modalPlusComponentsRef"
        v-if="modalProductAddComponents.ver"
        producto="TEMPORARY"
        :collapseOpen="false"
        :processCustomStore="true"
      />

      <!-- Cabecera -->
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <strong>Componentes temporales</strong>
          <p class="text-color-gray">Los componentes temporales se asignan al producto al finalizar el paso 7.</p>
        </div>

        <!-- Botón abrir el modal de agregar componentes -->
        <b-button
          @click="modalProductAddComponents.ver = true,
            searchComponent = ''"
          class="pull-right mb-2"
          variant="primary"
        >
          <i class="fa fa-plus fa-lg mr-1"></i>
          Agregar Componente
        </b-button>
      </div>

      <br />
      <!-- Historial de componentes -->
      <table class="table hover">
        <thead class="bg-gray-100">
          <tr>
            <th width="30%">Componente</th>
            <th width="20%">Nombre Personalizado</th>
            <th width="10%">N.CAS</th>
            <th width="5%">Simbolo</th>
            <th width="5%">%</th>
            <th width="12%">Simbolo hasta</th>
            <th width="8%">% hasta</th>
            <th width="5%">Estado</th>
            <th width="5%">Subproducto</th>
            <th width="5%">Eliminar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="component in components" :key="component.id">
            <td>{{ component.componentFather.name }}</td>
            <td>{{ component.custom_component }}</td>
            <td>{{ component.componentFather.cas_number }}</td>
            <td>{{ component.percentaje_symbol_from }}</td>
            <td>{{ component.percentaje_from }}</td>
            <td>{{ component.percentaje_symbol_until }}</td>
            <td>{{ component.percentaje_until }}</td>
            <td>
              <span class="badge p-2" :class="component.visible ? 'badge-primary' : 'badge-light'">
                {{ component.visible ? 'VISIBLE' : 'NO VISIBLE' }}
              </span>
            </td>
            <td>
              <span class="badge p-2" :class="component.subproduct ? 'badge-primary' : 'badge-light'">
                {{ component.subproduct ? 'SI' : 'NO' }}
              </span>
            </td>
            <td>
              <b-button size="sm" variant="danger" @click="deleteComponent(component.id)">
                <i class="fa fa-trash"></i>
              </b-button>
            </td>
          </tr>
          <tr v-if="components.length == 0">
            <td colspan="9" class="text-center">No hay componentes</td>
          </tr>
        </tbody>
      </table>

    </div>
    <br />

    <!-- Navegación -->
    <b-row>
      <b-col>
        <button class="btn btn-secondary float-left" @click="setModalPaso(0)">
          Anterior
        </button>
        <button class="btn btn-primary float-right" @click="nextStep()">
          Siguiente
        </button>
        <button class="btn btn-secondary float-right mr-2" @click="setModalVer(false)">
          Cancelar
        </button>
      </b-col>
    </b-row>

  </div>
</template>

<script>

// Vuex
import { mapState, mapMutations } from 'vuex';

// componentes
import ModalPlusComponents from '../ModalProductoComponente.vue';

export default {
  name: 'components-steps-create-products',
  data() {
    return {
      searchComponent: '',
    }
  },
  components: {
    ModalPlusComponents
  },
  async mounted() {
  },
  computed: {
    ...mapState('pasoapaso', ['components']),
    ...mapState('nuevocas', {
      modalProductAddComponents: 'modal_producto_componente'
    }),
  },
  methods: {
    ...mapMutations('pasoapaso', ['setModalPaso', 'setModalVer', 'setComponents']),
    /**
     * Ir al siguiente paso.
     * @author Fernando Claros
     */
    nextStep() {
      this.setModalPaso(2);
    },
    /**
     * Eliminar componente temporal.
     * @author Fernando Claros
     */
    deleteComponent(componentId) {
      this.setComponents(this.components.filter(component => component.id !== componentId));
    }
  }
};
</script>

<style>
.padding-content{
  padding: 20px;
}

.table-components-temporary {
  min-width: 400px;
  overflow-x: auto;
}

.table-components-temporary table{
  font-size: 13px;
}

.text-color-gray{
  color: gray;
}
.table-components-temporary .badge-primary {
    color: #ffff;
    background: #097b83;
}
.table-components-temporary .badge {
    font-weight: bold;
}
</style>
